import { useCallback } from 'react';
import { pick } from 'ramda';
import { getURLParam } from 'js/utils/url.util';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import * as server from './server';

export const useRegister = () => {
    const {
        clientPlatform,
        uaOrigin
    } = useDeviceSelector(pick(['clientPlatform', 'uaOrigin']));
    const {
        casinoName,
        clientSkin,
        clientVersion,
        clientType: appClientType
    } = useAppSelector(pick(['casinoName', 'clientSkin', 'clientVersion', 'clientType']));
    const clientType = getURLParam(location.search, 'clientType') || appClientType;

    return useCallback(async ({
        addressDetails,
        contactAddress,
        dataMap,
        depositLimits,
        betLimits,
        lossLimits,
        betLimitsAction,
        lossLimitsAction,
        contactPreferences,
        tags,
        token,
        blackbox
    }) => {
        const {
            data: {
                playerCode,
                userId,
                actions
            }
        } = await server.createPlayerInfo({
            addressDetails,
            blackbox,
            casinoName,
            contactAddress,
            dataMap: {
                ...casinoName && { casinoName },
                ...clientSkin && { clientSkin },
                ...clientType && { clientType },
                ...clientPlatform && { clientPlatform },
                ...clientVersion && { signupClientVersion: clientVersion },
                ...uaOrigin && { signupUserAgent: uaOrigin },
                ...dataMap
            },
            token
        });

        const {
            userName,
            email
        } = dataMap;

        if (depositLimits || betLimits || lossLimits || betLimitsAction || lossLimitsAction || contactPreferences || tags) {

            await server.sendBatchRequest({
                authParameters: {
                    casinoName, ...userName && { playerName: userName }, ...email && { email }
                },
                depositLimits,
                betLimits,
                lossLimits,
                betLimitsAction,
                lossLimitsAction,
                contactPreferences,
                tags
            });
        }

        return {
            playerCode,
            userId,
            actions
        };
    }, [uaOrigin, clientType, casinoName, clientPlatform, clientVersion, clientSkin]);
};
